import React, { useState } from 'react';

const Header = () => {
  const [showAbout, setShowAbout] = useState(false);

  return (
    <>
      <header className="py-4 px-6 md:px-12 bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            <img 
              src="/pics/logo-vanila-web.png" 
              alt="Vanilla Beauty Clinic" 
              className="h-10 md:h-12 w-auto" 
            />
            <h1 className="text-2xl font-bold text-primary-600">Vanilla Beauty Clinic</h1>
          </div>
          <nav className="flex items-center gap-4">
            <button 
              onClick={() => setShowAbout(true)}
              className="hidden md:inline-block text-gray-600 font-semibold hover:text-primary-600 transition-all"
            >
              Về Vanila Clinic
            </button>
            <a 
              href="#cta-section" 
              className="hidden md:inline-block px-5 py-2 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all shadow-primary"
            >
              Tư vấn ngay
            </a>
          </nav>
        </div>
      </header>

      {/* About Modal */}
      {showAbout && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowAbout(false)}
        >
          <div 
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6 md:p-8">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Về Vanila Beauty Clinic</h2>
                <button 
                  onClick={() => setShowAbout(false)}
                  className="text-gray-400 hover:text-gray-600 text-2xl"
                >
                  ×
                </button>
              </div>
              <div className="space-y-4 text-gray-600">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  Tiên phong công nghệ, Tận tâm vì bạn.
                </h3>
                <p className="leading-relaxed">
                  Vanila không chỉ là một thẩm mỹ viện. Chúng tôi là sự kết hợp giữa công nghệ làm đẹp tiên tiến và đội ngũ chuyên gia hàng đầu, tận tâm mang đến vẻ đẹp tự nhiên và an toàn nhất cho bạn.
                </p>
                <p className="leading-relaxed">
                  Với sứ mệnh "Vẻ đẹp của bạn, sứ mệnh của chúng tôi", Vanila cam kết mọi liệu trình đều được cá nhân hoá để phù hợp hoàn hảo với riêng bạn.
                </p>
                <div className="mt-6 p-4 bg-primary-50 rounded-lg border border-primary-200">
                  <p className="text-sm text-primary-700">
                    <strong>Demo AI:</strong> Ứng dụng này sử dụng Clipdrop API để demo các tính năng AI xử lý ảnh.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;